"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/Controls/AddPatients.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Button = require('web/components/Form/Button/Button');
var _AddRecipientsMenu = require('web/screens/Broadcast/Recipients/AddRecipientsMenu'); var _AddRecipientsMenu2 = _interopRequireDefault(_AddRecipientsMenu);











/* Edit message (pressed while its panel is open), and Rev 30 Z1's Add more:
 * the shared Add menu (Rev 31 v2), each item opening its dialog over the
 * table. The shared secondary button (Rev 28 S4). */
const AddPatients = ({
  campaignKey,
  isDisabled = false,
  onEditMessage,
  onAddExisting,
  onAddFromCsv,
  activePanel = null,
}) => {
  return (
    _react2.default.createElement('div', { className: "campaign-controls--edit", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
      , _react2.default.createElement('button', {
        type: "button",
        disabled: isDisabled,
        'aria-pressed': activePanel === 'message',
        className: _classBuilder2.default.call(void 0, _Button.btnClassName, _Button.secondaryBtnClassName, 'campaign-controls--edit-button'),
        onClick: onEditMessage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}

        , _react2.default.createElement('img', { src: "/assets/icons/header/edit-dark.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}} ), "Edit message"

      )
      , _react2.default.createElement(_AddRecipientsMenu2.default, {
        label: "Add more" ,
        campaignKey: campaignKey,
        isDisabled: isDisabled,
        onAddExisting: onAddExisting,
        onAddFromCsv: onAddFromCsv,
        className: "campaign-controls--add-more", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
      )
    )
  )
}

exports. default = AddPatients
